import AddAddressButton from "components/Addresses/components/AddAddressButton";
import PreLoader from "components/PreLoader/PreLoader";
import styled from "styled-components";

export const Spinner = styled(PreLoader)`
  position: absolute;
  width: 20px;
  height: 14px;
  transform-origin: 0 10px;
  transform: scale(0.5);
`;

export const AddressesWrapper = styled("div")`
  @media (min-width: ${({ theme }) => theme.breakpoints.md}px) {
    padding-top: 17px;
  }
`;

export const Form = styled.form`
  ${AddressesWrapper} {
    border: none;
    border-bottom: 1px solid ${(props) => props.theme.divider};
  }
`;

export const AddButton = styled(AddAddressButton)`
  padding: 10px 30px;

  ${({ theme }) => theme.sm`
    padding: 20px;
  `}
`;
